var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExportArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 15,
    viewBox: "0 0 8 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.45264 1.40074C4.71875 0.447393 3.28103 0.447393 2.54715 1.40074L0.637384 3.88159C-0.290644 5.08714 0.568755 6.83325 2.09013 6.83325L3.4999 6.83325L3.4999 13.6666C3.4999 13.9428 3.72375 14.1666 3.9999 14.1666C4.27604 14.1666 4.4999 13.9428 4.4999 13.6666V6.83325H5.90965C7.43102 6.83325 8.29043 5.08714 7.3624 3.88159L5.45264 1.40074ZM3.33955 2.01073C3.67314 1.5774 4.32664 1.5774 4.66023 2.01074L6.56999 4.49159C6.99182 5.03956 6.60119 5.83325 5.90965 5.83325L2.09013 5.83325C1.39859 5.83325 1.00796 5.03956 1.42979 4.49159L3.33955 2.01073Z",
    fill: "#1573FE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExportArrow);
export default __webpack_public_path__ + "static/media/export-arrow.1ff76619dfd17be0cee22edfad46ea59.svg";
export { ForwardRef as ReactComponent };